/**
 * This mixin provides visibility to things a widget can  support when
 * used when inside a popover.
 */
export default {
    props: {
        popoverIndex: {type: String, default: '0'}
    },
    methods: {
        closePopover: function () {
            this.$emit('actClose');
        }
    },
    computed: {
        childIndex: function () {
            return parseInt(this.popoverIndex) + 1;
        }
    }
}